<template>
  <v-layout>
    <v-btn @click="handleShowForm">
      <v-icon small>fa-plus-circle</v-icon>
      Add services by list of slides from DP
    </v-btn>

    <v-dialog v-model="showModal" max-width="1000" persistent>
      <v-card>
        <v-card-title class="headline">Add services by list of slides from DP</v-card-title>

        <v-card-text>
           <v-data-table
                :loading="loading"
                v-model="selectedServices"
                :headers="headers"
                :items="slidesByServices"
                select-all
                item-key="stainId"
                class="elevation-1"
            >
                <template v-slot:items="props">
                <tr :active="props.selected" @click="props.selected = !props.selected">
                    <td>
                    <v-checkbox
                        :input-value="props.selected"
                        primary
                        hide-details
                    ></v-checkbox>
                    </td>
                    <td>{{ props.item.stainNames }}</td>
                    <td>{{ getServiceName(props.item) }}</td>
                    <td>{{ props.item.count }}</td>
                    <td>{{ props.item.isFromIncomingBlock ? 'Yes' : 'No' }}</td>
                </tr>
                </template>
            </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn @click="handleHideForm">Cancel</v-btn>
          <v-btn @click="handleFormSubmit">Add All Selected</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
    import ServiceSelect from '../../Ui/mcc/ServiceSelect'
    import NumberInput from '../../Ui/NumberInput'
    import AmountInput from "../../Ui/AmountInput";
    import {notNullFactory, positiveFactory} from "../../../validation/rules";
    import {mapActions, mapState} from "vuex";
    import {notificationService} from "../../../application";
    import DateTimeInput from "../../Ui/DateTimeInput";
    import moment from 'moment';

    export default {
        name: 'add-case-service-by-slides-form',
        components: {
            ServiceSelect,
            NumberInput,
            AmountInput,
            DateTimeInput
        },
        props: {
            caseId: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                showModal: false,
                isValid: false,
                slidesByStains: [],
                slidesByServices: [],
                selectedServices: [],
                headers: [
                    { text: 'Stain', value: 'stain' },
                    { text: 'Service', value: 'service' },
                    { text: 'Count', value: 'count' },
                    { text: 'Is From Incoming Block ', value: 'isFromIncomingBlock' }
                ],
            }
        },
        computed: {
            ...mapState({
                availableSlideService: "availableSlideService",
                availableServices: "availableServices",
                availableStains: "availableStains"
            }),
        },
        created() {
            this.loading = true
            this.getCaseSlideStainForService({caseId: this.caseId}).then((data) => { 
                this.slidesByStains = data; 
                let byServices = []

                for (let i of data) {
                    let serviceId = this.getServiceId(i)
    
                    let notFound = true
                    for (let s of byServices){
                        if (s.serviceId === serviceId) {
                            notFound = false
                            s.count += i.count
                            s.stainNames.push(this.getStainName(i.stainId))
                        }
                    }

                    if (!notFound){
                        continue
                    }

                    byServices.push({
                        ...i,
                        serviceId: serviceId,
                        count: i.count,
                        stainNames: [this.getStainName(i.stainId)]
                    })
                }
                for (let s of byServices){
                    s.stainNames = s.stainNames.join(", ")
                }

                this.slidesByServices = byServices
                this.loading = false
            })
        },
        methods: {
            ...mapActions({
                addCaseService: 'addCaseService',
                getCaseSlideStainForService: 'getCaseSlideStainForService'
            }),
            getStainName(id){
                let item = _.find(this.availableStains, item => {
                    return item.id === id
                });

                if(!item){
                    return "Stain not found"
                }

                return `${item.title}`
            },
            getServiceName(data){
                let slideService = _.find(this.availableSlideService, item => {
                    return item.stainId === data.stainId && item.isFromIncomingBlock === data.isFromIncomingBlock
                });
                
                if(!slideService){
                    return "Stain Service not found in reference"
                }
                
                let service = _.find(this.availableServices, item => {
                    return item.id === slideService.serviceId
                });

                if(!service){
                    return "Service not found"
                }

                return `(${service.code}) ${service.title}`
            },

            getServiceId(data){
                let slideService = _.find(this.availableSlideService, item => {
                    return item.stainId === data.stainId && item.isFromIncomingBlock === data.isFromIncomingBlock
                });
                
                if(!slideService){
                    return null
                }
                
                let service = _.find(this.availableServices, item => {
                    return item.id === slideService.serviceId
                });

                if(!service){
                    return null
                }

                return service.id
            },

            handleShowForm() {
                this.showModal = true
            },
            handleHideForm() {
                this.showModal = false
            },
            handleFormSubmit() {
                for (let selectedService of this.selectedServices){
                    let requested = {
                        quantity: selectedService.count,
                        comment: "",
                        occurredAt: moment(),
                        price: null
                    };

                    let executed = {
                        quantity: selectedService.count,
                        comment: "",
                        occurredAt: moment()
                    }

                    this.addCaseService({
                        caseId: this.caseId,
                        serviceId: this.getServiceId(selectedService),
                        requested: requested,
                        executed: executed
                    })
                    .then(() => {
                        notificationService.info('Operation success');
                        this.showModal = false
                    })
                    .catch(e => {
                        notificationService.error('Operation failed');
                        throw e
                    })
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Sales/case/AddCaseServiceBySlidesForm.vue